// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./styles/main.scss");
var __webpack_exports__ = __webpack_require__("./scripts/main.js");
